module.exports = "/packs/default-user-profile-e8a07d228bc881d4432617c23a774101.png";